import { render } from "./NearSettingsPage.vue?vue&type=template&id=24c21f42"
import script from "./NearSettingsPage.vue?vue&type=script&lang=js"
export * from "./NearSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__